import React, { useEffect, useState } from "react";
import axios from "axios";
import { APIurl, BaseIurl } from "../../App";
import Button from "../../common/Button";

export default function EAAdviserInfo() {

  const username = localStorage.getItem("email");

  const [robot, setRobot] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!username) return;

    axios.post(APIurl, {
      cmd: "getrobotbymentor",
      username: username
    })
    .then(res => {
       console.log(res.data); // <-- Check backend output
      if (res.data.success) {
        setRobot(res.data.data);
      } else {
        setRobot(null);
      }
      setLoaded(true);
    })
    .catch(() => {
      setRobot(null);
      setLoaded(true);
    });

  }, [username]);

  if (!loaded) return null;

  const handleEdit = () => {
    // Navigate to edit page or open modal
    window.location.href = "/editea"; // Example path
  };
const handleDelete = () => {
  if (!window.confirm("Are you sure you want to delete this EA?")) return;

  axios.post(APIurl, {
    cmd: "deleterobot",
    username: username // we use mentor's email to identify their EA
  })
  .then(res => {
    if (res.data.success) {
      alert("EA deleted successfully");
      setRobot(null); // clear from front-end
    } else {
      alert("Failed to delete EA: " + res.data.data);
    }
  })
  .catch(() => alert("Server error while deleting EA"));
};


  return (
    <div className="mb-3">
      {robot ? (
        <>
          <hr />
          <h4>My Expert Adviser:</h4>
          <hr />
          <div className="p-3 rounded bg-white box-hover transition-all-1s d-flex align-items-center">
            
            {/* Thumbnail */}
            <div className="mr-3">
              <img 
                src={`${BaseIurl}Thumpnails/${robot.url_pic}`} 
                alt="EA Thumbnail" 
                style={{ width: 80, height: 80, borderRadius: 8, objectFit: "cover" }} 
              />
            </div>

            {/* EA Info */}
            <div className="flex-grow-1">
              <h6 className="mb-1">{robot.name}</h6>
              <p className="mb-1 text-muted">{robot.description}</p>

              <div className="d-flex flex-wrap align-items-center mb-1">
                <span className="mr-3"><b>Price:</b> R{robot.price}</span>
                <span className="mr-3">
                  <b>Total Users:</b> {robot.users || 0}
                </span>
                <span className="mr-3 d-flex align-items-center">
                  <b>Theme:</b> 
                  <span 
                    style={{ 
                      display: "inline-block", 
                      width: 20, 
                      height: 20, 
                      backgroundColor: robot.colors || "#000", 
                      marginLeft: 5, 
                      borderRadius: 4 
                    }} 
                  />
                </span>
              </div>

              <div className="mb-2">
                <b>Allowed Symbols:</b> {robot.symbols?.split(",").join(", ")}
              </div>

              {/* Buttons */}
              <div className="mt-2">
                <button 
                  className="btn btn-primary mr-2"
                  onClick={handleEdit}
                >
                  Edit EA Information
                </button>
                <button 
                  className="btn btn-danger"
                  onClick={handleDelete}
                >
                  Delete EA
                </button>
              </div>

            </div>
          </div>
        </>
      ) : (
        <div>
          <h5 className="text-danger mb-2">
            You don't have an Expert Adviser linked to your account
          </h5>
          <Button
            title="Add EA (Expert Adviser)"
            active="btn-deactive my-2"
            path="addea"
          />
        </div>
      )}
    </div>
  );
}
